import axios from 'axios';
import {getApiConfig} from '../config/configProvider';
import {HTTP_STATUS} from '../constants/constants';

export default class CheckoutApi {
  static processCheckout(basketUuid, data, headers) {
    const config = getApiConfig();
    const basketUrl = `${config.orderUrl}/baskets`;
    const url = `${basketUrl}/${basketUuid}/order`;
    return axios.post(url, data, {headers}).then(res => res.data);
  }

  static processNonCardPayment(orderId, headers) {
    const config = getApiConfig();
    const url = `${config.orderUrl}/orders/${orderId}/authorize`;
    return axios.put(url, null, {headers}).then(res => res.status);
  }

  static processUrlPayment(url, data) {
    return axios.post(url, data).then(res => res.data);
  }

  static getCardOnFild(headers) {
    const url = `/api/order/v2/card-on-file/provider-config`;
    return axios.get(url, {headers}).then(res => res.data);
  }

  static savedCardPayment(url, headers) {
    return axios.put('/api/order' + url, null, {headers}).then(res => {
      if (res.status === HTTP_STATUS.ACCEPTED) {
        return 'OK';
      }
      return res.data;
    });
  }
}
